// THIS FILE WILL BE FILLED WITH OTHER STORES CREATION FOR PLATFORMS LATER
import { API } from '@app/constants/api';
import { CreateSheinStorePayload } from '@app/pages/redirection/types';
import { IStore } from '@typings/store';
import axios, { AxiosResponse } from 'axios';

export const createSheinStore = async (
  companyId: string,
  payload: CreateSheinStorePayload
): Promise<AxiosResponse<{ store: IStore }>> => {
  return (
    (await axios.post(`${API.endpoint}/companies/${companyId}/shein/stores`, {
      store: { ...payload },
    })) || {}
  );
};
